import { ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { DisplayText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassCheckoutTitle = (props: ComponentProps<typeof DisplayText>) => {
  const { children, ...restProps } = props;

  return (
    <DisplayText
      sizeMatch={['24', '40', '48']}
      accessibilityRole="header"
      aria-level={1}
      style={styles.container}
      {...restProps}
    >
      {children}
    </DisplayText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
});
